import { Component, inject } from '@angular/core';
import { Api } from '../../services/api';

@Component({
  selector: 'app-home',
  imports: [],
  templateUrl: './home.html',
  styleUrl: './home.css',
})
export class Home {
  private readonly api = inject(Api);

  protected test = () => {
    this.api.test().subscribe((res) => console.log(res));
  };

  protected test2 = () => {
    this.api.createParticle("material-15e861b7-4247-4f54-94fe-1d5c85081ff2%23main%3A0").subscribe((res) => console.log(res));
  };
}
